import { APIClient } from '@frontend/api-utils';
import { ChangeBasicAuthPassword, Identification } from '@frontend/identification/types';

export class IdentificationBasicAuthClient extends APIClient {
    public static readonly endpoint = '/identification-api/v1';

    public static async changePassword(accountId: string, userId: string, body: ChangeBasicAuthPassword): Promise<Identification> {
        const response = await this.post(`${this.endpoint}/accounts/${accountId}/users/${userId}/change-password`, body);
        return await this.handleResponse<Identification>(response);
    }
}
